import "./LineSeparator.css";

export function LineSeparator() {

    return <div className="line-separator"></div>
}
